module.exports = __webpack_public_path__ + "img/87-c5e98c.png";